"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _accordion = _interopRequireDefault(require("./accordion"));

/**
 * Accordion, or a wrapper that orchestrates multiple panels.
 *
 * @displayName Accordion (Web)
 * @class Accordion
 * @public
 */
class Accordion extends _accordion.default {
  /**
   * Renders the title element, if title is defined and not empty.
   *
   * @returns {React.DOM} renders accordion title
   * @private
   */
  title() {
    if (typeof this.props.title !== 'undefined' && this.props.title !== '') {
      return /*#__PURE__*/_react.default.createElement("h1", {
        className: "text-center"
      }, this.props.title);
    }

    return null;
  }
  /**
   * Render the accordion.
   *
   * @returns {React.DOM} Wrapping div for the accordion
   * @private
   */


  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: this.props.className
    }, this.title(), /*#__PURE__*/_react.default.createElement("div", {
      className: "ux-accordion",
      "aria-multiselectable": "true",
      role: "tablist",
      "aria-live": "polite"
    }, this.panels()));
  }

}
/**
 * Property validation.
 *
 * @type {object}
 * @public
 */


exports.default = Accordion;
Accordion.propTypes = {
  /** Which panel should be open by default. */
  open: _propTypes.default.number,

  /** The actual collapsible panels. */
  children: _propTypes.default.node.isRequired,

  /** The title for the accordion. */
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),

  /** Optional className */
  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.array])
};